<script setup lang="ts">
import { TooltipProvider, type TooltipProviderProps, useForwardProps } from "reka-ui"

const props = withDefaults(defineProps<TooltipProviderProps>(), {
  delayDuration: 200,
})

const forwardedProps = useForwardProps(props)
</script>

<template>
  <TooltipProvider v-bind="forwardedProps">
    <slot />
  </TooltipProvider>
</template>
